const resources = {
    showMore: 'Afficher plus',
    rougeBadge: 'ROUGE',
    signInToAccess: 'Login',
    joinToAccess: 'Join',
    viewAll: 'Voir tout'
};

export default function getResource(label) {
    return resources[label];
}
